import { graphql, Link } from 'gatsby'
import { useEffect, useState } from 'react'
import axios from 'axios'
import PageLayout from '../components/PageLayout/PageLayout'
import SubpageHeader from '../components/SubpageHeader/SubpageHeader'
import { getMetaTags } from '../utils/metaTags'
import styles from './privacynotice.module.scss'

export default function LayoutPrivacyNotice({ pageContext }) {
  const [privacyNotice, setPrivacyNotice] = useState(null)

  useEffect(() => {
    axios.get('/.netlify/functions/privacyNotice').then(response => {
      setPrivacyNotice(response.data)
    })
  }, [])

  return (
    <PageLayout>
      <SubpageHeader
        title={pageContext.title}
        summary={pageContext.subtitle}
        metaTags={getMetaTags(pageContext)}
      />

      {privacyNotice && (
        <div className={styles.wrapper}>
          <div className={styles.container}>
            <div className={styles.content}>
              <div className={styles.privacyNotice}>
                <div
                  className={styles.summaryChanges}
                  dangerouslySetInnerHTML={{
                    __html: privacyNotice.summaryChanges,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </PageLayout>
  )
}

export const pageQuery = graphql`
  query ($id: ID!) {
    strapiGQL {
      page(id: $id) {
        ...StrapiGQL_PagesWithContentZones
      }
    }
  }
`
